<template>
  <div>
    <div>
      <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo mb-0">Documentos Solicitados</h3>
        <v-container fluid v-if="anexos.length > 0">
          <v-layout wrap align-center white pa-0 class="area-conteudo anexo">
            <v-flex xs12 sm12 md6 class="adionar-bordar" v-for="(documento, index) in anexos" :key="index">
                  <span v-if="documento.descricao.length < 50">
                        <i v-if="['ANALISADO'].includes(documento.situacao)" class="fas fa-check green--text mr-1"
                           title="Documento Analisado" aria-hidden="true"></i>
                        <v-tooltip top @click.native.stop v-else-if="['AGUARDANDO_REENVIO'].includes(documento.situacao)">
                          <i slot="activator" class="fas fa-info-circle orange--text mr-1" aria-hidden="true"></i>
                          {{documento.motivoReenvio}}
                        </v-tooltip>
                          <i v-else class="far fa-file-alt mr-1" aria-hidden="true"></i>
                        {{ documento.descricao }}
                  </span>
                  <span v-else>
                        <i v-if="['ANALISADO'].includes(documento.situacao)" class="fas fa-check green--text mr-1"
                           title="Documento Analisado" aria-hidden="true"></i>
                        <v-tooltip top @click.native.stop v-else-if="['AGUARDANDO_REENVIO'].includes(documento.situacao)">
                          <i slot="activator" class="fas fa-info-circle orange--text mr-1" aria-hidden="true"></i>
                          {{documento.motivoReenvio}}
                        </v-tooltip>
                        <i v-else class="far fa-file-alt mr-1" aria-hidden="true"></i>
                        <span :title="documento.descricao">{{ documento.descricao.slice(0, 50) }}...</span>
                  </span>
              <br>

              <div
                  v-if="['NAO_ANALISADO', 'AGUARDANDO_ENVIO', 'AGUARDANDO_REENVIO'].includes(documento.situacao) && (documento.uri) && situacaoCompraDireta!=='ENCERRADA'">
                {{ documento.descricao.slice(0, 15) }}...

                <a @click="$emit('downloadAnexo', documento)"
                   class="anexo__botao-link">
                  <i class="fa fa-download" aria-hidden="true"></i>
                </a>
                <a v-show="['AGUARDANDO_ENVIO', 'AGUARDANDO_REENVIO'].includes(documento.situacao)" @click="$emit('removerDocumento', documento)"
                   class="anexo__botao-link remover">
                  <i class="fa fa-trash" aria-hidden="true"/>
                </a>
              </div>
              <div v-if="deveMostrarBotaoVerAnexo || ['ANALISADO'].includes(documento.situacao)">
                <a @click="$emit('downloadAnexo', documento)"
                   class="anexo__botao-link az-action-link-icon">
                  <i class="fas fa-search" aria-hidden="true"/>
                  Ver Anexo
                </a>

                <span v-if="deveMostrarBotaoAssinarDocumento(documento)">
                    <botao-assinar :urlDocumentoVirtualizado="documento.urlAssinatura"></botao-assinar>
                </span>

                <span v-else-if="documento.assinado" class="botao-assinado">
                  <i class="fas fa-check" aria-hidden="true"/>
                  Assinado
                </span>

              </div>
                <compra-direta-upload-arquivo
                  v-if="documentoAguardandoEnvioOuReenvio(documento) && (compraEmAnaliseOuReanalise() && !documento.uri)"
                  :ref="'azFileUploadAnexoDocumento' + index"
                  :multiple="false"
                  @error="tratarErroEnvioArquivo"
                  @uploadArquivo="tratarEventUploadArquivo($event, documento.documentoSolicitadoId)"
                  accept="application/pdf"
                  class="anexo__botao">
                <a @click="abrirSelecaoAnexo(index, documento.documentoSolicitadoId)" class="botao-anexo-proposta">
                  <i class="fas fa-paperclip" aria-hidden="true"></i>
                  Anexar
                </a>
              </compra-direta-upload-arquivo>

            </v-flex>

          </v-layout>
        </v-container>

        <v-divider v-if="anexos && ((anexos.length % 2) === 1)"></v-divider>
        <v-layout wrap align-center white class="area-conteudo anexo">
          <v-flex xs12 sm12 md6 class="adionar-bordar">
            <p>
              <i class="far fa-file-alt mr-1" aria-hidden="true"></i>
              <strong>Protocolo Proposta</strong>
            </p>

            <div>
              <a
                  slot="activator"
                  @click="tratarEventoCliqueDownloadProtocolo"
                  target="_blank"
                  class="anexo__botao-link">
                <i class="fa fa-download" aria-hidden="true"/>
              </a>
              <botao-assinar v-if="deveMostrarBotaoAssinarProtocolo"
                             id="idButtonAssinarProtocolo"
                             :urlDocumentoVirtualizado="protocolo.urlAssinatura"/>

              <span v-else-if="protocolo.assinado" class="botao-assinado">
                  <i class="fas fa-check" aria-hidden="true"/>
                  Assinado
                </span>

            </div>
          </v-flex>
          <v-flex xs12 sm12 md6 class="adionar-bordar">
            <p>
              <i class="far fa-file-alt mr-1" aria-hidden="true"></i>
              <strong>Termo de Aceite</strong>
            </p>

            <div>
              <a
                  slot="activator"
                  @click="tratarEventoCliqueDownloadTermo"
                  target="_blank"
                  class="anexo__botao-link">
                <i class="fa fa-download" aria-hidden="true"/>
              </a>
              <botao-assinar v-if="deveMostrarBotaoAssinarTermo" id="idButtonAssinarTermo" :urlDocumentoVirtualizado="termo.urlAssinatura"/>

              <span v-else-if="termo.assinado" class="botao-assinado">
                  <i class="fas fa-check" aria-hidden="true"/>
                  Assinado
                </span>

            </div>
          </v-flex>

        </v-layout>
        <v-divider></v-divider>
        <div class="az-actions-form botao-enviar-anexos">
          <botao-enviar-anexos
              v-if="!ehCompraSuspensa"
              :desabilitarEnvio="deveDesabilitarBotaoEnviar"
              @enviar="$emit('enviarAnexos')"/>
        </div>
      </v-flex>
    </div>

    <modal-opcoes-download
        :exibirModal="mostrarOpcoesDownload"
        :assinado="relatorioAssinado"
        @selecionarOpcao="emitirEventoDownload"
        @fechar="fecharModalOpcoesDownload">
    </modal-opcoes-download>
  </div>
</template>

<script>

import {actionTypes} from '@/core/constants'
import CompraDiretaUploadArquivo from '@/views/pages/commons/upload-arquivo/CompraDiretaUploadArquivo'
import BotaoEnviarAnexos from '@/views/components/BotaoEnviarAnexos'
import {mapState} from 'vuex'
export default {
    name: 'Anexo',
    components: {CompraDiretaUploadArquivo, BotaoEnviarAnexos},
    props: {
        anexos:{
            type: Array,
            default: () =>{
                return []
            }
        },
        situacaoCompraDireta: {
            type: String,
            default: null
        },
        idProtocoloVirtualizado: {
            type: String,
            default: null
        },
        protocoloAssinado: {
            type: Boolean,
            default: null
        },
        urlProtocoloVirtualizado: {
            type: String,
            default: null
        },
        isProtocoloSolicitadoAssinatura: {
            type: Boolean,
            default: false
        },
        termo: {
            type: Object,
            default: () => {}
        },
        protocolo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            repository: 'repo1:compradireta',
            anexoTemporario: {},
            pendingDocumentoSolicitadoId: null,
            urlAtual: null,
            mostrarOpcoesDownload: false,
            ehDocumentoSolicitadoClicado: false,
            relatorioAssinado: false,
            ehProtocolo: false
        }
    },
    computed: {
        ...mapState(['resumoProposta']),
        deveMostrarBotaoAssinarTermo() {
            return this.termo.virtualizado && this.termo.solicitadoAssinatura && !this.termo.assinado && this.termo.urlAssinatura
        },
        deveMostrarBotaoAssinarProtocolo() {
            return this.protocolo.virtualizado && this.protocolo.solicitadoAssinatura && !this.protocolo.assinado && this.protocolo.urlAssinatura
        },
        ehCompraSuspensa: function () {
            return ['SUSPENSA'].includes(this.situacaoCompraDireta)
        },
        deveDesabilitarBotaoEnviar: function () {
            return this.anexos.every(documento => documento.situacao === 'ANALISADO' || documento.situacao === 'NAO_ANALISADO')
        },
        deveMostrarBotaoVerAnexo: function () {
            return this.situacaoCompraDireta === 'ENCERRADA'
        },
        ehCompraVirtualizada() {
            return this.resumoProposta.virtualizada
        }
    },
    methods: {
        abrirSelecaoAnexo(index, documentoSolicitadoId) {
            this.pendingDocumentoSolicitadoId = documentoSolicitadoId
            this.anexoTemporario = { documentoSolicitadoId }
            const refName = `azFileUploadAnexoDocumento${index}`
            let uploader = this.$refs[refName]
            if (Array.isArray(uploader)) {
                uploader = uploader[0]
            }
            if (uploader && typeof uploader.openFileSelector === 'function') {
                uploader.openFileSelector()
            }
        },
        clearAnexoTemporarioState() {
            this.anexoTemporario = {}
            this.pendingDocumentoSolicitadoId = null
        },
        extensaoArquivoValida(nomeArquivo) {
            const extensao = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'), nomeArquivo.length)
            return extensao === '.pdf' || extensao === '.PDF'
        },
        deveMostrarBotaoAssinarDocumento(documento) {
            return documento.solicitadoAssinatura && !documento.assinado && documento.urlAssinatura
        },
        fecharModalOpcoesDownload() {
            this.mostrarOpcoesDownload = false
            this.ehProtocolo = false
        },
        abrirModalOpcoesDownload() {
            this.mostrarOpcoesDownload = true
        },
        tratarEventoCliqueDownloadProtocolo() {
            if (this.idProtocoloVirtualizado != null && this.ehCompraVirtualizada) {
                this.ehProtocolo = true
                this.abrirModalOpcoesDownload()
                this.relatorioAssinado = this.protocoloAssinado
            } else {
                this.$emit('gerarRelatorioProtocoloPreview')
            }
        },
        tratarEventoCliqueDownloadTermo() {
            if (this.termo.idVirtualizado != null && this.ehCompraVirtualizada) {
                this.ehProtocolo = false
                this.abrirModalOpcoesDownload()
                this.relatorioAssinado = this.termo.assinado
            } else {
                this.$emit('downloadTermoAceite', null, null)
            }
        },
        emitirEventoDownload(tipoDownload) {

            if(this.ehProtocolo) {
                if (this.idProtocoloVirtualizado) {
                    this.$emit('gerarRelatorioProtocolo', this.idProtocoloVirtualizado, tipoDownload)
                } else {
                    throw new Error('Id de virtualização não encontrado.')
                }
            } else {
                if (this.termo.idVirtualizado) {
                    this.$emit('downloadTermoAceite', this.termo, tipoDownload)
                } else {
                    throw new Error('Id de virtualização não encontrado.')
                }
            }

            this.fecharModalOpcoesDownload()
        },
        documentoAguardandoEnvioOuReenvio(documento){
            return ['AGUARDANDO_ENVIO', 'AGUARDANDO_REENVIO'].includes(documento.situacao)
        },
        compraEmAnaliseOuReanalise(){
            return ['EM_ANALISE', 'REANALISE'].includes(this.situacaoCompraDireta)
        },

        async tratarEventUploadArquivo(event, documentoSolicitadoId){
            if (!event || !event.filename || !event.formData) {
                this.mostrarNotificacaoErro('Falha ao ler o arquivo selecionado. Por favor, tente novamente.')
                this.resetUploadedFiles()
                this.clearAnexoTemporarioState()
                return
            }

            if (!this.extensaoArquivoValida(event.filename)) {
                this.mostrarNotificacaoErro('Extensão do arquivo inválida. Por favor, faça upload de um arquivo .pdf')
                this.resetUploadedFiles()
                this.clearAnexoTemporarioState()
                return
            }

            try {
                if (documentoSolicitadoId && !this.pendingDocumentoSolicitadoId) {
                    this.pendingDocumentoSolicitadoId = documentoSolicitadoId
                }
                if (!this.anexoTemporario || typeof this.anexoTemporario !== 'object') {
                    this.anexoTemporario = {}
                }
                if (documentoSolicitadoId && !this.anexoTemporario.documentoSolicitadoId) {
                    this.anexoTemporario.documentoSolicitadoId = documentoSolicitadoId
                }
                const { arquivo }  = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, event.formData)
                this.adicionarAnexoCarregado(arquivo)
            } catch(e) {
                this.mostrarNotificacaoErro('Falha no envio do arquivo. Tente novamente.')
                this.clearAnexoTemporarioState()
            } finally {
                this.resetUploadedFiles()
            }
        },
        async adicionarAnexoCarregado(arquivo) {
            if (arquivo) {
                if (!this.anexoTemporario || typeof this.anexoTemporario !== 'object') {
                    this.anexoTemporario = {}
                }
                if (!this.anexoTemporario.documentoSolicitadoId) {
                    this.anexoTemporario.documentoSolicitadoId = this.pendingDocumentoSolicitadoId
                }
                this.anexoTemporario.anexo = {
                    nome: arquivo.nome,
                    uri: arquivo.uri
                }
                this.$emit('adicionarAnexo', this.anexoTemporario)
                this.clearAnexoTemporarioState()
            }
        },
        tratarErroEnvioArquivo(err) {
            if (err && err.type === 'FILE_EXCEEDED_MAX_SIZE_LIMIT') {
                this.mostrarNotificacaoErro(`O arquivo selecionado deve ter no máximo ${this.$store.state.loki.file.maxSize}.`)
            } else {
                this.mostrarNotificacaoErro('Falha ao processar arquivo. Tente novamente.')
            }
            this.clearAnexoTemporarioState()
            this.resetUploadedFiles()
        },
    },
}
</script>

<style lang="stylus">
.adionar-bordar
  border 1px solid #ebebeb
  padding 10px 15px
  border-right none

  a.botao-anexo-proposta
    background-color transparent !important
    border 1px solid var(--v-primary-base) !important
    color var(--v-primary-base) !important
    padding 5px 10px

    i
      color var(--v-primary-base) !important


    &:hover, &:active, &:focus
      background-color var(--v-primary-lighten1) !important
      border 1px solid var(--v-primary-lighten1) !important
      color: white !important

      i
        color: white !important

.anexo
  color #888

  .flex
    display flex
    justify-content space-between
    align-items center
    padding-right 20px
    margin-top 0

  .flex:nth-child(even)
    padding-right 0

  .flex:nth-child(1), .flex:nth-child(2)
    margin-top 0

  p
    margin-bottom 0
    margin-right 10px

  &__botao .az-drop-file
    padding 0
    margin 0
    border 0
    background-color #fff
    height auto !important

  &__botao-link
    background-color #fff
    color #888
    padding 5px 10px 5px 10px
    min-width 50px

    i
      color #777 !important
      font-size 13px
      top 0

    &:hover, &:active, &:focus
      background-color #e4e4e4
      border 0 !important

  .az-drop-file .center
    min-width 110px

.botao-enviar-anexos
  display table
  margin 0 auto
  padding-top 10px
  padding-bottom 10px

@media (max-width 991px)
  .anexo .flex
    padding-right 0
    margin-bottom 20px

.botao-assinado
  background-color #fff
  color #888
  padding 5px 10px 5px 5px
  min-width 50px

  i
    color #777 !important
    font-size 13px
    top 0

</style>
